
import { Vue } from "vue-class-component";

export default class Coupon extends Vue {}
